export default "__VITE_PUBLIC_ASSET__31a8d3f1__"